(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["schematic-page"]) return;
  try {
    
if (!customElements.get('schematic-page-app')) {
  customElements.define('schematic-page-app', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) { window.addEventListener('hashchange', this.onHash); return; }
      this.ready = true;
      this.data = JSON.parse(this.querySelector('[data-schematic-data]').textContent);
      this.family = this.dataset.family;
      this.familyModels = Object.keys(this.data.models).filter(k => this.data.models[k].family === this.family);
      this.model = this.familyModels[0];
      this.select = this.querySelector('[data-model]');
      this.search = this.querySelector('[data-search]');
      this.familyModels.forEach(k => {
        const option = document.createElement('option');
        option.value = k;
        option.textContent = (this.data.model_labels || {})[k] || k;
        this.select.append(option);
      });
      this.applyHash();
      this.assembly = this.assemblyKeys(this.model)[0];
      this.onHash = () => { this.applyHash(); this.search.value = ''; this.render(); };
      window.addEventListener('hashchange', this.onHash);
      this.select.addEventListener('change', () => {
        this.model = this.select.value;
        const url = new URL(location.href);
        url.hash = new URLSearchParams({model:this.model}).toString();
        history.replaceState(null, '', url);
        this.search.value = '';
        this.render();
      });
      this.search.addEventListener('input', () => this.renderRows());
      this.querySelectorAll('[data-zoom]').forEach(button => button.addEventListener('click', () => {
        this.querySelectorAll('[data-zoom]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        const canvas = this.querySelector('[data-canvas]');
        canvas.style.width = Number(button.dataset.zoom) * 100 + '%';
        canvas.style.maxWidth = 'none';
      }));
      this.render();
    }
    disconnectedCallback() { window.removeEventListener('hashchange', this.onHash); }
    assemblyKeys(model) {
      const keys = Object.keys(this.data.models[model].assemblies);
      const rank = k => k === 'et1' ? 2 : (k === 'head' ? 1 : 0);
      return keys.sort((a, b) => rank(a) - rank(b));
    }
    applyHash() {
      const requested = new URLSearchParams(location.hash.slice(1)).get('model');
      if (this.data.models[requested]?.family === this.family) this.model = requested;
      else {
        const sku = new URLSearchParams(location.hash.slice(1)).get('sku');
        const matched = this.familyModels.find(k => (this.data.models[k].machine_skus || []).includes(sku));
        if (matched) this.model = matched;
      }
      this.select.value = this.model;
    }
    url(path) {
      const url = new URL(path, location.origin);
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      return url.href;
    }
    renderAssemblies() {
      const keys = this.assemblyKeys(this.model);
      if (!keys.includes(this.assembly)) this.assembly = keys[0];
      const group = this.querySelector('[data-assemblies]');
      group.replaceChildren();
      group.hidden = keys.length < 2;
      keys.forEach(k => {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.assembly = k;
        button.textContent = (this.data.assembly_labels || {})[k] || k;
        button.setAttribute('aria-pressed', String(k === this.assembly));
        button.addEventListener('click', () => {
          this.assembly = k;
          this.search.value = '';
          this.render();
          this.querySelector('.schematic-viewport').scrollTo(0,0);
        });
        group.append(button);
      });
    }
    render() {
      this.renderAssemblies();
      const modelData = this.data.models[this.model];
      this.rows = modelData.assemblies[this.assembly];
      const diagram = this.data.diagrams[modelData.diagrams[this.assembly]];
      const label = (this.data.assembly_labels || {})[this.assembly] || this.assembly;
      this.querySelector('[data-assembly-title]').textContent = label;
      const img = this.querySelector('[data-diagram]');
      img.src = diagram.url;
      img.alt = ((this.data.model_labels || {})[this.model] || this.model) + ' — ' + label + ' exploded parts diagram';
      img.width = diagram.width;
      img.height = diagram.height;
      const hint = this.querySelector('[data-hint]');
      if (hint) hint.textContent = diagram.hotspots.length
        ? 'Blue numbers open parts. Gray numbers need confirmation. Zoom in and scroll to inspect the drawing.'
        : 'This drawing uses printed reference numbers - find yours in the parts list, or search by number.';
      const layer = this.querySelector('[data-hotspots]');
      layer.replaceChildren();
      diagram.hotspots.forEach(h => {
        const row = this.rows.find(r => r.ref === h.ref);
        if (!row) return;
        const link = document.createElement('a');
        link.className = 'schematic-hotspot' + (row.url ? '' : ' is-unlisted');
        link.textContent = h.label;
        link.style.left = h.x + '%';
        link.style.top = h.y + '%';
        link.style.width = h.w + '%';
        link.style.height = h.h + '%';
        if (h.small) link.style.fontSize = '8px';
        link.title = 'Ref. ' + h.label + ' · ' + (row.sku || '—') + ' · ' + row.description;
        link.setAttribute('aria-label', link.title);
        link.href = row.url ? this.url(row.url) : '#schematic-row-' + this.assembly + '-' + h.ref;
        if (!row.url) link.addEventListener('click', event => {
          event.preventDefault();
          this.search.value = '';
          this.renderRows();
          const target = this.querySelector('[id="schematic-row-' + this.assembly + '-' + h.ref + '"]');
          if (!target) return;
          target.scrollIntoView({block:'center',behavior:'smooth'});
          target.focus({preventScroll:true});
        });
        layer.append(link);
      });
      this.renderRows();
    }
    renderRows() {
      const query = this.search.value.trim().toLowerCase();
      const visible = this.rows.filter(row => [row.ref,row.sku,row.description].join(' ').toLowerCase().includes(query));
      const body = this.querySelector('[data-rows]');
      body.replaceChildren();
      visible.forEach(row => {
        const tr = document.createElement('tr');
        tr.id = 'schematic-row-' + this.assembly + '-' + row.ref;
        tr.tabIndex = -1;
        const ref = document.createElement('td');
        ref.textContent = row.ref;
        const sku = document.createElement('td');
        const number = document.createElement(row.url ? 'a' : 'span');
        number.textContent = row.sku || '—';
        if (row.url) number.href = this.url(row.url);
        sku.append(number);
        const description = document.createElement('td');
        description.textContent = row.description;
        if (!row.url) {
          const note = document.createElement('span');
          note.className = 'schematic-unlisted';
          note.textContent = this.data.unlisted_note || 'Please contact us to confirm this part.';
          description.append(note);
        }
        tr.append(ref,sku,description);
        body.append(tr);
      });
      this.querySelector('[data-count]').textContent = visible.length + ' parts shown';
      this.querySelector('[data-empty]').hidden = visible.length > 0;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
